import {
	FETCH_CHAT_USER_LIST_REQUEST,
	FETCH_CHAT_USER_LIST_SUCCESS,
	FETCH_CHAT_USER_LIST_FAILURE
} from "../../constants";

const initialState = {
	data: [],
	loading: false,
	error: null,
};

const chatUserListReducers = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_CHAT_USER_LIST_REQUEST:
			return {
				...state,
				loading: true,
				error: null
			};
		case FETCH_CHAT_USER_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			};
		case FETCH_CHAT_USER_LIST_FAILURE:
			return {
				...state,
				loading: false,
				data: [],
				error: action.payload,
			};
		default:
			return state;
	}
}

export default chatUserListReducers;
